export const getNumbersArray = (answer: string) =>
    answer
        .split("")
        .map((v) => parseInt(v, 10))
        .filter((v) => !Number.isNaN(v))
        .filter((value, index, array) => array.indexOf(value) === index);
